<template>
	<el-drawer title="历史信息" :visible.sync="show" :before-close="close" :close-on-press-escape="false" :destroy-on-close="true" :wrapperClosable="false" :size="450">
		<p style="font-size: 20px;font-weight: 700;padding-left: 10px;">姓名：{{user.name}}</p>
		<p class="tit">校区变更</p>
		<el-table stripe :data="initsch" style="width: 400px;margin-left: 10px;">
			<el-table-column  prop="name" label="校区" width="100"></el-table-column>
			<el-table-column  prop="startTimeS" label="起始日期" width="100"></el-table-column>
			<el-table-column  prop="endTimeS" label="截至日期" width="100"></el-table-column>
			<el-table-column  prop="duration" label="持续时间" width="100"></el-table-column>
		</el-table>
		<p class="tit">职务变更</p>
		<el-table stripe :data="initjob" style="width: 400px;margin-left: 10px;">
			<el-table-column  prop="name" label="职务" width="100"></el-table-column>
			<el-table-column  prop="startTimeS" label="起始日期" width="100"></el-table-column>
			<el-table-column  prop="endTimeS" label="截至日期" width="100"></el-table-column>
			<el-table-column  prop="duration" label="持续时间" width="100"></el-table-column>
		</el-table>
		<p class="tit">等级变更</p>
		<el-table stripe :data="initdj" style="width: 400px;margin-left: 10px;">
			<el-table-column  prop="name" label="等级" width="100"></el-table-column>
			<el-table-column  prop="startTimeS" label="起始日期" width="100"></el-table-column>
			<el-table-column  prop="endTimeS" label="截至日期" width="100"></el-table-column>
			<el-table-column  prop="duration" label="持续时间" width="100"></el-table-column>
		</el-table>
		<p class="tit">科目变更</p>
		<el-table stripe :data="initsub" style="width: 400px;margin-left: 10px;">
			<el-table-column  prop="name" label="主要科目" width="100"></el-table-column>
			<el-table-column  prop="startTimeS" label="起始日期" width="100"></el-table-column>
			<el-table-column  prop="endTimeS" label="截至日期" width="100"></el-table-column>
			<el-table-column  prop="duration" label="持续时间" width="100"></el-table-column>
		</el-table>
		<p style="height: 20px;"></p>
	</el-drawer>
</template>

<script>
export default{
	name:'oldinf',
	data() {
		return {
			sch:[],
			job:[],
			dj:[],
			sub:[]
		}
	},
	props:{
		user:{
			type:Object
		},
		show:{
			type:Boolean
		}
	},
	computed:{
		initsch(){
			let arr=[]
			this.sch.forEach(e=>{
				let obj={
					name:e.name,
					startTimeS:e.stime,
					endTimeS:e.etime,
					duration:this.myfun.timelong(e.stime,e.etime),
				}
				if(arr.length===0){
					arr.push(obj)
					return
				}
				if(arr[arr.length-1].startTimeS===obj.startTimeS){
					arr[arr.length-1].name+="/"+obj.name
					return
				}
				arr.push(obj)
			})
			return arr
		},
		initjob(){
			let arr=[]
			this.job.forEach(e=>{
				let obj={
					name:e.name,
					startTimeS:e.stime,
					endTimeS:e.etime,
					duration:this.myfun.timelong(e.stime,e.etime),
				}
				if(arr.length===0){
					arr.push(obj)
					return
				}
				if(arr[arr.length-1].startTimeS===obj.startTimeS){
					arr[arr.length-1].name+="/"+obj.name
					return
				}
				arr.push(obj)
			})
			return arr
		},
		initdj(){
			let arr=[]
			this.dj.forEach(e=>{
				arr.push({
					name:e.dj1+e.dj2,
					startTimeS:e.stime,
					endTimeS:e.etime,
					duration:this.myfun.timelong(e.stime,e.etime),
				})
			})
			return arr
		},
		initsub(){
			let arr=[]
			this.sub.forEach(e=>{
				arr.push({
					name:e.nj+e.sub,
					startTimeS:e.stime,
					endTimeS:e.etime,
					duration:this.myfun.timelong(e.stime,e.etime),
				})
			})
			return arr
		}
	},
	watch:{
		show(n){
			if(!n){
				return
			}
			//获取用户历史信息
			this.myfun.Loading()
			const formdata = new FormData()
			formdata.append("userid",this.user.id)
			this.axios.post("data:getoldinf",formdata).then(e=>{
				this.myfun.Loadingclose()
				if(!e)return
				this.sch=e.sch
				this.job=e.job
				this.dj=e.dj
				this.sub=e.sub
			})
		}
	},
	methods:{
		close(){
			this.$emit("close")
		}
	}
}
</script>

<style scoped>
.tit{
	font-size: 18px;
	font-weight: 700;
	line-height: 30px;
	padding-left: 20px;
	margin-bottom: 10px;
	margin-top: 20px;
}
.tit:first-child{
	margin-top: 0px;
}
</style>
